
    import { VueAgile } from 'vue-agile';
    import { mapActions } from 'vuex';

    export default {
        name: 'ProjectCarousel',
        components: {
            agile: VueAgile,
        },
        props: {
            currentProjectSlug: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                drag: false,
                options: {
                    navButtons: false,
                    dots: false,
                    infinite: true,
                    responsive: [
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                            },
                        },
                        {
                            breakpoint: 900,
                            settings: {
                                slidesToShow: 2,
                            },
                        },
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 4,
                            },
                        },
                    ],
                },
            };
        },
        computed: {
            projectsExceptCurrent() {
                return this.$store.state.projectsData.filter(
                    (obj) => obj.slug !== this.currentProjectSlug,
                );
            },
        },
        created() {
            if (this.$store.state.projectsData.length === 0) {
                this.getProjects();
            }
        },
        methods: {
            ...mapActions([
                'setProjectsData',
            ]),
            getProjects() {
                this.$getDataFromCache(`/wp-json/wp/v2/projects?per_page=100`)
                    .then((response) => {
                        this.setProjectsData(response.data);
                    });
            },
            redirectToPage(name, slug) {
                this.$router.push({name, params: { slug } });
            },
            showCurrentSlide(value, time) {
                setTimeout(() => {
                    this.drag = value;
                }, time)

            }
        }
    };
